import { render, staticRenderFns } from "./LivePublishPlanItem.vue?vue&type=template&id=3daca074&scoped=true"
import script from "./LivePublishPlanItem.vue?vue&type=script&lang=js"
export * from "./LivePublishPlanItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daca074",
  null
  
)

export default component.exports